import HelpRexOutlineSVG from './icon_help_rex_outline.svg';
import withIconProps from './withIconProps';

export default withIconProps(HelpRexOutlineSVG);
